import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeePenalty  {
    _originalTypeClassName = "zERP.BO.EmployeePenalty";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeePenalty.translate = translateService;
}
this.Files = [];
this.PenaltyMisconductPairs = [];
this.Id = null;
this.Code = null;
this.PenaltyDate = null;
this.ImpositionAct = null;
this.PenaltySummary = null;
this.IsFinal = false;
this.UpdatesPayroll = false;
this.Notes = null;
this.IsForgiven = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
PenaltyDate:any;
ImpositionAct:any;
PenaltySummary:any;
IsFinal:any;
UpdatesPayroll:any;
Notes:any;
IsForgiven:any;
DisciplinaryBoard:any;
Employee:any;
Files:any;
PenaltyMisconductPairs:any;
StatuteOfLimitations:any;
static setDisciplinaryBoard = ($this, value) => {
var oldValue = $this.DisciplinaryBoard;
$this.DisciplinaryBoard = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setFiles = ($this, items) => {
                if (items == null) items = [];
                if ($this.Files == null) $this.Files = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Files.length > 0) {
                    Domain.EmployeePenalty.removeFiles($this, $this.Files[0]);
                }

                Domain.EmployeePenalty.addManyFiles($this, copyItems);
            }
static addManyFiles = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePenalty.addFiles($this, items[i]);
                }
            }
static addFiles = ($this, item) => {
                if ($this.Files == null) $this.Files = [];
                if (item == null || $this.Files.indexOf(item) > -1) return;
                $this.Files.push(item);
}
static addRangeFiles = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePenalty.addFiles($this, item));
            }
static removeFiles = ($this, item) => {
                if ($this == null || $this.Files == null || $this.Files.indexOf(item) === -1) return;
                var _index = $this.Files.indexOf(item);
                $this.Files.splice(_index, 1);
}
static clearFiles = ($this) => { $this.Files = null; }
static setPenaltyMisconductPairs = ($this, items) => {
                if (items == null) items = [];
                if ($this.PenaltyMisconductPairs == null) $this.PenaltyMisconductPairs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PenaltyMisconductPairs.length > 0) {
                    Domain.EmployeePenalty.removePenaltyMisconductPairs($this, $this.PenaltyMisconductPairs[0]);
                }

                Domain.EmployeePenalty.addManyPenaltyMisconductPairs($this, copyItems);
            }
static addManyPenaltyMisconductPairs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmployeePenalty.addPenaltyMisconductPairs($this, items[i]);
                }
            }
static addPenaltyMisconductPairs = ($this, item) => {
                if ($this.PenaltyMisconductPairs == null) $this.PenaltyMisconductPairs = [];
                if (item == null || $this.PenaltyMisconductPairs.indexOf(item) > -1) return;
                $this.PenaltyMisconductPairs.push(item);
if (item.EmployeePenalty != $this) {
Domain.EmployeePenaltyMisconductPair.setEmployeePenalty(item, $this);
}
}
static addRangePenaltyMisconductPairs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmployeePenalty.addPenaltyMisconductPairs($this, item));
            }
static removePenaltyMisconductPairs = ($this, item) => {
                if ($this == null || $this.PenaltyMisconductPairs == null || $this.PenaltyMisconductPairs.indexOf(item) === -1) return;
                var _index = $this.PenaltyMisconductPairs.indexOf(item);
                $this.PenaltyMisconductPairs.splice(_index, 1);
item.EmployeePenalty = null;
}
static clearPenaltyMisconductPairs = ($this) => { $this.PenaltyMisconductPairs = null; }
static setStatuteOfLimitations = ($this, value) => {
var oldValue = $this.StatuteOfLimitations;
$this.StatuteOfLimitations = value;
if (value != null) {
if (oldValue != null && oldValue.EmployeePenalty != null) { oldValue.EmployeePenalty = null; }
if ($this.StatuteOfLimitations.EmployeePenalty !== $this) {
Domain.StatuteOfLimitations.setEmployeePenalty(value, $this);
}
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}